import { AngularSvgIconModule } from 'angular-svg-icon';
import { VibrationsChart } from '../../models/charts/VibrationsChart';
import { VibrationChartHorizontalComponent } from '../vibration-chart-horizontal/vibration-chart-horizontal.component';
import { CommonModule } from '@angular/common';
import { EventData } from '../../../features/vibration-events/models/event-data';
import { VibrationsChartChannel } from '../../models/charts/VibrationsChartChannel';
import { RecordsAssignmentComponent } from '../records-assignment/records-assignment.component';
import { ControlPoint } from '../../models/controlPoint';
import { Site } from '../../models/site';
import { ControlPointsService } from '../../../features/control-points/services/control-points-service';
import { EventService } from '../../../features/vibration-events/services/event-service';
import { Subject } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { VibrationsRecordService } from '../../services/records/vibrations-record.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { FonctionsService } from '../../services/utilities/fonctions.service';
import { DistanceModalComponent } from '../distance-modal/distance-modal.component';
import { NotesModalComponent } from '../notes-modal/notes-modal.component';
import * as turf from "@turf/turf";
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportService, ControlPointInfoDto } from '@shared/services/report/report.service';
import { CurrentStateService } from 'app/core/services/current-state.service';
import { PonderationService } from '@shared/services/ponderation/ponderation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ReportControlPointSelectionModalComponent, ReportGenerationParams } from '../../../features/report/report-control-point-selection-modal/report-control-point-selection-modal.component';
import { LocalStorageService } from '@shared/services/utilities/local-storage.service';
import { Seismograph } from '@shared/models/seismograph';
import { SeismographService } from '@features/seismograph-devices/services/seismograph-service';

@Component({
  selector: 'app-record-detail',
  imports: [
    AngularSvgIconModule,
    VibrationChartHorizontalComponent,
    CommonModule,
    RecordsAssignmentComponent,
    TranslateModule
  ],
  templateUrl: './record-detail.component.html',
  styleUrl: './record-detail.component.scss',
})


export class RecordDetailComponent implements OnInit, OnDestroy, OnChanges {
  @Input() siteId: number;
  @Input() siteName: string;
  @Input() eventData: EventData;
  @Input() currentControlPoint: number;
  @Input() currentDevice: Seismograph;
  @Input() vibrationRecords: VibrationsChart[];
  isEventAssigned: boolean = false;
  isControlPointAssigned: boolean = false;
  isdeviceAssigned: boolean = false;
  @Input() isDetailsVisible: boolean[] = [];
  fourChannelCheck: boolean = false;
  isMoreThanFour: boolean = false;
  selectedTab: string = 'main';
  @Input() selectedRecordId: number;
  selectedRecordIndex: number = -1;
  @Input() controlPoints: ControlPoint[];
  @Input() events: EventData[] = [];
  private unsubscribe$ = new Subject<void>();
  @Input() ponderations: any[] = [];
  selectedPonderationId: number | null = null;
  isDownloading: boolean = false;
  selectedRecordIds: Set<number> = new Set<number>();
  private previewImageCache = new Map<string, string | null>();
  selectedPreviewChannel: number = 1;
  highlightedRecordId: number | null = null;
  private autoFocusedRecordId: number | null = null;

  get allSelected(): boolean {
    return this.vibrationRecords?.length > 0 && this.vibrationRecords.every(r => this.selectedRecordIds.has(r.id));
  }

  toggleSelection(id: number): void {
    if (this.selectedRecordIds.has(id)) {
      this.selectedRecordIds.delete(id);
    } else {
      this.selectedRecordIds.add(id);
    }
  }

  toggleSelectAll(): void {
    if (this.allSelected) {
      this.selectedRecordIds.clear();
    } else {
      this.vibrationRecords.forEach(r => this.selectedRecordIds.add(r.id));
    }
  }

  async deleteSelected(): Promise<void> {
    if (this.selectedRecordIds.size === 0) return;
    const dialogRef = this.dialogConfirme.open(ConfirmDialogComponent, {
      enterAnimationDuration: '0ms',
      data: {
        title: this.translate.instant('MESSAGE_INFO.DELETE_RECORD_TITLE'),
        message: this.translate.instant('MESSAGE_INFO.DELETE_RECORD_MESSAGE')
      },
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (!result) return;
      try {
        const ids = Array.from(this.selectedRecordIds);
        await this.vibrationRecordsService.deleteRecordsBulk(this.siteId, ids);
        this.vibrationRecords = this.vibrationRecords.filter(r => !this.selectedRecordIds.has(r.id));
        this.selectedRecordIds.clear();
        this.translate.get('MESSAGE_INFO.RECORD_DELETED_SUCCESS').subscribe((t: string) => {
          this.fonctionsService.launch_toast(true, t);
        });
        this.cdr.detectChanges();
      } catch (error) {
        this.translate.get('MESSAGE_INFO.RECORD_DELETED_ERROR').subscribe((t: string) => {
          this.fonctionsService.launch_toast(false, t);
        });
      }
    });
  }
  constructor(
    private controlPointsService: ControlPointsService,
    private eventService: EventService,
    private vibrationRecordsService: VibrationsRecordService,
    private dialogConfirme: MatDialog,
    private fonctionsService: FonctionsService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private reportService: ReportService,
    private currentStateService: CurrentStateService,
    private ponderationService: PonderationService,
    private localStorageService: LocalStorageService,
    private seismographService: SeismographService
  ) {

    if (this.vibrationRecords) {
      this.vibrationRecords.forEach(() => {
        this.isDetailsVisible.push(false);
      });
      if(this.selectedRecordId != null && this.selectedRecordId >= 0) {
        this.selectedRecordIndex = this.vibrationRecords.findIndex(record => record.id === this.selectedRecordId);
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRecordId'] && !changes['selectedRecordId'].firstChange) {
      this.autoFocusedRecordId = null;
    }

    if (changes['vibrationRecords'] && this.vibrationRecords && !changes['vibrationRecords'].firstChange) {
      this.tryAutoFocusSelectedRecord();
    }

    if (changes['selectedRecordId'] && this.vibrationRecords?.length) {
      this.tryAutoFocusSelectedRecord();
    }
  }

  ngOnInit(): void {
    this.loadEvents();
    this.loadControlPoints();
    this.route.queryParams.subscribe(params => {
      this.siteId = +params['siteId'];
    });

    this.tryAutoFocusSelectedRecord();
  }

  private tryAutoFocusSelectedRecord(): void {
    if (!this.selectedRecordId || !this.vibrationRecords?.length) {
      return;
    }

    if (this.autoFocusedRecordId === this.selectedRecordId) {
      return;
    }

    const targetIndex = this.vibrationRecords.findIndex(record => record.id === this.selectedRecordId);
    if (targetIndex < 0) {
      return;
    }

    // Lock immediately to avoid duplicate execution from lifecycle re-entries.
    this.autoFocusedRecordId = this.selectedRecordId;

    this.selectedRecordIndex = targetIndex;
    this.isDetailsVisible[targetIndex] = true;

    this.ponderationService.getPonderation(this.siteId, this.vibrationRecords[targetIndex].controlPointId).subscribe({
      next: () => {
        this.loadSignalData(targetIndex);
      }
    });

    setTimeout(() => {
      const element = document.getElementById(`record-row-${this.selectedRecordId}`);
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.highlightedRecordId = this.selectedRecordId;

      setTimeout(() => {
        if (this.highlightedRecordId === this.selectedRecordId) {
          this.highlightedRecordId = null;
        }
      }, 2500);
    }, 150);
  }

  public findMaxAbsValue(min: number, max: number) {
    return Math.abs(max) > Math.abs(min) ? max : Math.abs(min);
  }
  getMaximumFrequency(channels: VibrationsChartChannel[]): number {
    if (channels?.length > 0) {
      return Math.max(...channels?.map(channel => channel.frequencySpectrum.maximumFrequencyHz));
    }
    return 0;
  }

  getPicPPV(channels: VibrationsChartChannel[]): number {
    if (channels?.length > 0) {
      const allExceptLastChannel = channels?.slice(0, -1);
      return Math.max(
        ...allExceptLastChannel.map(channel =>
          this.findMaxAbsValue(channel.timeSpectrum.ppvMin, channel.timeSpectrum.ppvMax)
        )
      );
    }
    return 0;
  }

  getPicPPVFirstThree(record: VibrationsChart): number {
    const channels = record?.signalDataEntity?.signalData?.channels;
    if (channels?.length > 0) {
      const firstThree = channels.slice(0, 3);
      return Math.max(
        ...firstThree.map(channel =>
          this.findMaxAbsValue(channel.timeSpectrum.ppvMin, channel.timeSpectrum.ppvMax)
        )
      );
    }
    const meta = record?.recordMetadata;
    const ppvs = [meta?.verticalPpv, meta?.longitudinalPpv, meta?.transversePpv]
      .filter(v => v != null && !Number.isNaN(Number(v))) as number[];
    if (ppvs.length > 0) {
      return Math.max(...ppvs.map(v => Math.abs(v)));
    }
    return meta?.picVibration ?? 0;
  }

  getMaxFrequencyFirstThree(record: VibrationsChart): number {
    const channels = record?.signalDataEntity?.signalData?.channels;
    if (channels?.length > 0) {
      const firstThree = channels.slice(0, 3);
      return Math.max(...firstThree.map(channel => channel.frequencySpectrum.maximumFrequencyHz));
    }
    return record?.recordMetadata?.maxFrequency ?? 0;
  }

  formatMaxFrequency(record: VibrationsChart): string {
    const frequency = Number(this.getMaxFrequencyFirstThree(record));
    if (!Number.isFinite(frequency) || frequency <= 0) {
      return '--';
    }
    return `${frequency.toFixed(frequency >= 10 ? 0 : 1)} Hz`;
  }

  shouldShowPreviewFrequency(record: VibrationsChart): boolean {
    return record?.recordMetadata?.recordType !== 'Bargraph';
  }

  formatRecordLength(record: VibrationsChart): string {
    const length = Number(record?.recordMetadata?.recordLength);
    if (!Number.isFinite(length) || length <= 0) {
      return '--';
    }

    if (length >= 3600) {
      return `${(length / 3600).toFixed(1)} h`;
    }
    if (length >= 60) {
      return `${(length / 60).toFixed(1)} min`;
    }
    return `${length.toFixed(length >= 10 ? 0 : 1)} s`;
  }

  private getChannelPreviewImageSrc(record: VibrationsChart, channel: number): string | null {
    const cacheKey = `${record?.id ?? 'no-id'}-${channel}`;
    if (this.previewImageCache.has(cacheKey)) {
      return this.previewImageCache.get(cacheKey) ?? null;
    }

    const raw = this.getChannelPreviewRaw(record, channel);
    if (raw == null) {
      return null;
    }

    if (typeof raw === 'string') {
      const fromString = raw.startsWith('data:image/') ? raw : `data:image/png;base64,${raw}`;
      this.previewImageCache.set(cacheKey, fromString);
      return fromString;
    }

    let bytes: Uint8Array | null = null;
    if (raw instanceof Uint8Array) {
      bytes = raw;
    } else if (Array.isArray(raw)) {
      bytes = new Uint8Array(raw);
    } else if (Array.isArray(raw?.data)) {
      bytes = new Uint8Array(raw.data);
    }

    if (!bytes || bytes.length === 0) {
      this.previewImageCache.set(cacheKey, null);
      return null;
    }

    let binary = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.slice(i, i + chunkSize);
      binary += String.fromCharCode(...chunk);
    }
    const mimeType = this.detectPreviewMimeType(bytes);
    const dataUrl = `data:${mimeType};base64,${btoa(binary)}`;

    this.previewImageCache.set(cacheKey, dataUrl);
    return dataUrl;
  }

  getSelectedPreviewImageSrc(record: VibrationsChart): string | null {
    return this.getChannelPreviewImageSrc(record, this.getSelectedPreviewChannel(record));
  }

  getSelectedPreviewChannel(record: VibrationsChart): number {
    const available = this.getAvailablePreviewChannels(record);
    if (available.length === 0) {
      return this.selectedPreviewChannel;
    }
    return available.includes(this.selectedPreviewChannel) ? this.selectedPreviewChannel : available[0];
  }

  hasPreviewChannels(record: VibrationsChart): boolean {
    return this.getAvailablePreviewChannels(record).length > 0;
  }

  hasMultiplePreviewChannels(record: VibrationsChart): boolean {
    return this.getAvailablePreviewChannels(record).length > 1;
  }

  showNextPreviewChannel(): void {
    this.selectedPreviewChannel = this.selectedPreviewChannel === 3 ? 1 : this.selectedPreviewChannel + 1;
  }

  showPreviousPreviewChannel(): void {
    this.selectedPreviewChannel = this.selectedPreviewChannel === 1 ? 3 : this.selectedPreviewChannel - 1;
  }

  private getAvailablePreviewChannels(record: VibrationsChart): number[] {
    const available: number[] = [];
    for (let channel = 1; channel <= 3; channel++) {
      const raw = this.getChannelPreviewRaw(record, channel);
      if (this.hasPreviewData(raw)) {
        available.push(channel);
      }
    }
    return available;
  }

  private getChannelPreviewRaw(record: VibrationsChart, channel: number): any {
    const meta: any = record?.recordMetadata;
    if (!meta) {
      return null;
    }
    return meta[`channel${channel}PreviewImage`] ?? meta[`Channel${channel}PreviewImage`];
  }

  private hasPreviewData(raw: any): boolean {
    if (raw == null) return false;
    if (typeof raw === 'string') return raw.length > 0;
    if (raw instanceof Uint8Array) return raw.length > 0;
    if (Array.isArray(raw)) return raw.length > 0;
    if (Array.isArray(raw?.data)) return raw.data.length > 0;
    return false;
  }

  private detectPreviewMimeType(bytes: Uint8Array): string {
    if (bytes.length >= 8 &&
      bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) {
      return 'image/png';
    }
    if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
      return 'image/jpeg';
    }
    if (bytes.length >= 2 && bytes[0] === 0x42 && bytes[1] === 0x4d) {
      return 'image/bmp';
    }
    return 'image/png';
  }

  pascalToDecibel(pressure: number): number | null {
    if(pressure == null) return null;
    const referencePressure = 20e-6;
    return 20 * Math.log10(pressure / referencePressure);
  }

  setTab(tab: string): void {
    this.selectedTab = tab;
  }

  toggleDetails(index: number): void {
    this.isDetailsVisible[index] = !this.isDetailsVisible[index];
    this.selectedRecordIndex = index;
    if (this.isDetailsVisible[index]) {
     this.ponderationService.getPonderation(this.siteId, this.vibrationRecords[this.selectedRecordIndex].controlPointId).subscribe({
            next: (response) => {
              // this.ponderations = response.data;              
              this.loadSignalData(this.selectedRecordIndex);
            }
          });
    }
  }

  private updateVibrationRecords(index: number, updatedRecord: any): void {
    this.vibrationRecords = [
      ...this.vibrationRecords.slice(0, index),
      updatedRecord,
      ...this.vibrationRecords.slice(index + 1),
    ];
  }


  loadControlPoints(): void {
    this.controlPointsService.getControlPointsBySiteId(this.siteId, false).subscribe(response => {
      this.controlPoints = response;
    })
  }

  async loadEvents(): Promise<void> {
    const response = await this.eventService.getVibrationEventsAsync(this.siteId);
    this.events = response.data;
  }

  getControlPointName(controlPointId: number): string {
    const controlPoint = this.controlPoints?.find(cp => cp.controlPointId === controlPointId);
    if (this.controlPoints == undefined) {
      return '';
    }
    return controlPoint ? controlPoint.name : '';
  }

  getEvent(eventId: number): EventData {
    if (this.events.length == 0) return null;
    return this.events.find(cp => cp.id === eventId);
  }

  onDistanceEdit(record: VibrationsChart, index: number): void {
    const event = this.getEvent(record.eventId);
    const controlPoint = this.controlPoints?.find(cp => cp.controlPointId === record?.controlPointId);

    const distance = record.distance != null ? record.distance : this.calculateDistance(event, controlPoint);

    this.dialogConfirme.open(DistanceModalComponent, {
      enterAnimationDuration: '0ms',
      data: {
        distance,
        record: this.vibrationRecords[index],
        siteId: this.siteId
      }
    });
  }

  private calculateDistance(event: any, controlPoint: any): number | null {
    if (!event || !controlPoint) return null;

    const from = turf.point([controlPoint.x, controlPoint.y]);
    const to = turf.point([event.positionCoordinates.x, event.positionCoordinates.y]);
    const options = { units: 'meters' as turf.Units };

    const rawDistance = turf.distance(from, to, options);
    return Number(rawDistance.toFixed(0));
  }

  onNotesEdit(index: number) {
    const dialogRef = this.dialogConfirme.open(NotesModalComponent, {
      enterAnimationDuration: '0ms',
      data: { record: this.vibrationRecords[index], siteId: this.siteId },
    });
  }

  async deleteRecord(recordId: string): Promise<void> {
    const dialogRef = this.dialogConfirme.open(ConfirmDialogComponent, {
      enterAnimationDuration: '0ms',
      data: { title: this.translate.instant('MESSAGE_INFO.DELETE_RECORD_TITLE'), message: this.translate.instant('MESSAGE_INFO.DELETE_RECORD_MESSAGE') },
    });
    dialogRef.afterClosed().subscribe(async result => {
      try {
        if (result) {
          await this.vibrationRecordsService.deleteRecords(this.siteId, recordId);
          this.vibrationRecords = this.vibrationRecords.filter(record => record.id.toString() !== recordId);
          this.translate.get('MESSAGE_INFO.RECORD_DELETED_SUCCESS').subscribe(
            (translation: string) => {
              this.fonctionsService.launch_toast(true, translation);
            }
          );
        }
      } catch (error) {
        this.translate.get('MESSAGE_INFO.RECORD_DELETED_ERROR').subscribe(
          (translation: string) => {
            this.fonctionsService.launch_toast(false, translation);
          }
        );
      }
    });
  }

  async openReportModal(): Promise<void> {
    const selectedDeviceSerials = new Set<string>();
    const selectedControlPointIds = new Set<number>();

    if (this.currentDevice?.serialNumber) {
      selectedDeviceSerials.add(this.currentDevice.serialNumber);
    }

    if (this.currentControlPoint) {
      selectedControlPointIds.add(this.currentControlPoint);
    } else if (this.currentDevice?.controlPointId) {
      selectedControlPointIds.add(this.currentDevice.controlPointId);
    }

    if (this.currentDevice?.id) {
      const deviceInstruments = await this.seismographService.getControlPointInstrumentsBySeismographsId([this.currentDevice.id]);
      deviceInstruments.forEach(instrument => {
        if (instrument?.controlPointId) {
          selectedControlPointIds.add(instrument.controlPointId);
        }
      });
    }

    if (this.currentControlPoint) {
      const controlPointInstruments = await this.seismographService.getSeismographsByControlPointIds([this.currentControlPoint]);
      controlPointInstruments.forEach(instrument => {
        if (instrument?.seismograph?.serialNumber) {
          selectedDeviceSerials.add(instrument.seismograph.serialNumber);
        }
      });
    }

    const currentDevice: Seismograph | null = this.currentDevice ? this.currentDevice : null;

    const dialogRef = this.dialogConfirme.open(ReportControlPointSelectionModalComponent, {
      width: '450px',
      disableClose: true,
      autoFocus: false,
      data: {
        siteId: this.siteId,
        controlPoints: this.controlPoints || [],
        devices: currentDevice ? [currentDevice] : [],
        selectedDeviceSerialNumbers: Array.from(selectedDeviceSerials),
        lockDevicesSelection: false,
        selectedControlPointIds: Array.from(selectedControlPointIds),
        lockControlPointsSelection: false,
        eventId: this.eventData?.id,
        eventName: this.eventData?.name,
        eventType: this.eventData?.eventTypeLabel,
        location: undefined,
        organisation: undefined
      }
    });

    dialogRef.afterClosed().subscribe((params: ReportGenerationParams) => {
      if (params) {
        this.generateMultiRecordReport(params);
      }
    });
  }

  private generateMultiRecordReport(params: ReportGenerationParams): void {
    const controlPointsDto: ControlPointInfoDto[] = params.controlPoints.map(cp => ({
      ControlPointId: cp.ControlPointId,
      ControlPointName: cp.ControlPointName
    }));

    this.currentStateService.setReportGenerationInProgress(true);
    this.reportService.generateVibrationReport(
      undefined, // recordId
      params.startDate,
      params.endDate,
      params.ponderationId,
      params.eventName,
      params.eventType,
      this.siteName,
      params.organisation,
      controlPointsDto,
      this.siteId,null,
      params.devices || null
    ).subscribe({
      next: (blob) => {
        this.downloadPDF(blob, `Report_MultiRecord_${new Date().toLocaleDateString('fr-FR')}.pdf`);
        this.currentStateService.setReportGenerationInProgress(false);
      },
      error: async (error) => {
        console.error('Error generating multi-record report:', error);
        const errorMessage = await this.extractErrorMessage(error);
        if (errorMessage) {
          this.fonctionsService.launch_toast(false, errorMessage);
        }
        this.currentStateService.setReportGenerationInProgress(false);
      }
    });
  }

  private loadSignalData(index: number): void {
    if (!this.vibrationRecords[index].signalDataEntity) {
      const record = this.vibrationRecords[index];
      this.vibrationRecordsService.GetRecordById(this.siteId, record.id, this.selectedPonderationId).subscribe({
        next: (response) => {
          const updatedRecord = {
            ...record,
            signalDataEntity: response.data.signalDataEntity,
            timeSpectrumWeighted: response.data.timeSpectrumWeighted
          };
          this.updateVibrationRecords(index, updatedRecord);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.translate.get('MESSAGE_INFO.ERROR_LOADING_VIBRATION_RECORD').subscribe(
            (translation: string) => {
              console.error(translation, err);
            }
          );
        }
      });
    }
  }

  downloadReport(record: VibrationsChart) {
    if (!record?.id) {
      console.error('No record ID provided for single record report');
      return;
    }

    this.currentStateService.setReportGenerationInProgress(true);
    this.reportService.generateVibrationReport(
      record.id,
      undefined,
      undefined,
      undefined,
      this.getEvent(record.eventId)?.name,
      this.getEvent(record.eventId)?.eventTypeLabel,
      this.siteName,
      undefined,
      undefined,
      this.siteId
    ).subscribe({
      next: (blob) => {
        this.downloadPDF(blob, `Report_Record_${record.id}_${new Date().toLocaleDateString('fr-FR')}.pdf`);
        this.currentStateService.setReportGenerationInProgress(false);
      },
      error: async (error) => {
        console.error('Error generating single record report:', error);
        const errorMessage = await this.extractErrorMessage(error);
        if (errorMessage) {
          this.fonctionsService.launch_toast(false, errorMessage);
        }
        this.currentStateService.setReportGenerationInProgress(false);
      }
    });
  }

  private downloadPDF(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  private async extractErrorMessage(error: any): Promise<string | null> {
    if (error?.error instanceof Blob) {
      try {
        const text = await error.error.text();
        const jsonError = JSON.parse(text);
        return jsonError.message || null;
      } catch (e) {
        return null;
      }
    }
    return error?.error?.message || error?.message || null;
  }

  isNaN(value: any): boolean {
    return Number.isNaN(Number(value));
  }


  openFile(vibrationRecord: VibrationsChart) {
    const  s3key = `Vibrations/${vibrationRecord.recordMetadata.seismographSerialNumber.toLowerCase()}/${vibrationRecord.recordMetadata.fileName}`;
    this.isDownloading = true;
    this.currentStateService.setShowLoading(true);
    this.vibrationRecordsService.getDownloadUrl(s3key).subscribe({
        next: (result) => {
            if (result && result.downloadUrl) {
              window.open(result.downloadUrl, '_blank');
              this.currentStateService.setShowLoading(false);
              this.isDownloading = false;
            }
        },
        error: (error: HttpErrorResponse) => {
        this.isDownloading = false;
        this.currentStateService.setShowLoading(false);
        },
      });
    
  }

  getSiteObject(): Site {
    const site = new Site();
    site.siteId = this.siteId;
    return site;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
